import { render } from "./OfferCard.vue?vue&type=template&id=2f119b8e&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"

import "./OfferCard.vue?vue&type=style&index=0&id=2f119b8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f119b8e"]])

export default __exports__